import api from './api';

const CAMPAIGN_MASTER_BASE_URL = '/campaign-master';

export const campaignMasterService = {
  // Get all campaigns with filtering and pagination
  getAllCampaigns: async (params = {}) => {
    try {
      const response = await api.get(CAMPAIGN_MASTER_BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error('Error getting campaigns:', error);
      throw error;
    }
  },

  // Get campaign by ID
  getCampaignById: async (id) => {
    try {
      const response = await api.get(`${CAMPAIGN_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting campaign:', error);
      throw error;
    }
  },

  // Create new campaign
  createCampaign: async (campaignData) => {
    try {
      const response = await api.post(CAMPAIGN_MASTER_BASE_URL, campaignData);
      return response.data;
    } catch (error) {
      console.error('Error creating campaign:', error);
      throw error;
    }
  },

  // Update campaign
  updateCampaign: async (id, campaignData) => {
    try {
      const response = await api.put(`${CAMPAIGN_MASTER_BASE_URL}/${id}`, campaignData);
      return response.data;
    } catch (error) {
      console.error('Error updating campaign:', error);
      throw error;
    }
  },

  // Delete campaign
  deleteCampaign: async (id) => {
    try {
      const response = await api.delete(`${CAMPAIGN_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting campaign:', error);
      throw error;
    }
  },

  // Get campaign statistics
  getCampaignStats: async () => {
    try {
      const response = await api.get(`${CAMPAIGN_MASTER_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error getting campaign stats:', error);
      throw error;
    }
  },

  // Get campaigns by status
  getCampaignsByStatus: async (status) => {
    try {
      const response = await api.get(`${CAMPAIGN_MASTER_BASE_URL}/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error getting campaigns by status:', error);
      throw error;
    }
  },

  // Get campaigns by type
  getCampaignsByType: async (type) => {
    try {
      const response = await api.get(`${CAMPAIGN_MASTER_BASE_URL}/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error getting campaigns by type:', error);
      throw error;
    }
  },

  // Update campaign status
  updateCampaignStatus: async (id, status) => {
    try {
      const response = await api.patch(`${CAMPAIGN_MASTER_BASE_URL}/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating campaign status:', error);
      throw error;
    }
  },

  // Add team member to campaign
  addTeamMember: async (id, teamMemberData) => {
    try {
      const response = await api.post(`${CAMPAIGN_MASTER_BASE_URL}/${id}/team-members`, teamMemberData);
      return response.data;
    } catch (error) {
      console.error('Error adding team member:', error);
      throw error;
    }
  },

  // Remove team member from campaign
  removeTeamMember: async (id, memberId) => {
    try {
      const response = await api.delete(`${CAMPAIGN_MASTER_BASE_URL}/${id}/team-members/${memberId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing team member:', error);
      throw error;
    }
  },

  // Get campaign analytics
  getCampaignAnalytics: async (id, params = {}) => {
    try {
      const response = await api.get(`${CAMPAIGN_MASTER_BASE_URL}/${id}/analytics`, { params });
      return response.data;
    } catch (error) {
      console.error('Error getting campaign analytics:', error);
      throw error;
    }
  }
};

export default campaignMasterService;
